module.exports = __webpack_public_path__ + "img/label_w.a38a5ad4.svg";